import req from "../http";

const employeePlant = {
  // 取得 plant
  getPlant(params) {
    return req("get", "/BasicInformation/EmployeePlant", params);
  }
};

export default employeePlant;